import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestCostsacct } from "../../entity/EntityRequestCostsacct";

export class DtoRequestCostsacctsGetRes extends EntityRequestCostsacct {
  public items: EntityRequestCostsacct[]  = [];
}
